export const AUTH_CONFIG = __config__.auth0
/*
export const AUTH_CONFIG =
 {
  domain: "stkgarching.eu.auth0.com",
  //192.168.178.32
  //clientId: 'C8f8FBBQs05Pei6zkTGhGNEA0S6BIA5C',
  //192.168.178.44
  clientId: "4L1rfiUEarmwMI8zeqDnFGzXsAxpJiDJ",
  audience: "http://192.168.178.44",
  callbackUrl: "http://192.168.178.44/callback"
};
*/
// ursprünglich über mein Auth0Lock
/*
export const AUTH_CONFIG = {
  domain: 'stringdb.eu.auth0.com',
   clientId: 'TYBv1hltZvypZDOzpAWYattV73xYbjLr',
   audience: 'http://192.168.178.32/',
   callbackUrl: 'http://192.168.178.32/callback'
}
*/
